module.exports = __webpack_public_path__ + "media/customizations/gareybldg/back-5edf7de6aeeef470538db435926e210f.jpg";